module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '1ge3eha6',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
